// extracted by mini-css-extract-plugin
export default {"wrapper":"A22BquX8TCrzfk6PHKFW","prefix":"x_yCQDJMpYFZ_AUaWyOX","condition":"VOe3bP17fv2PAL55R2oS","variableName":"IN3SCfLfXJV9MRjnPu57","formula":"DPuMU61GFSDcDUOk4Q30"};